import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getNotificationsRequest: [],
  getNotificationsSuccess: ['data'],
  getNotificationsFailure: [],
});

export const NotificationsTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
  error: false,
});

/* Reducers */

const getNotificationsRequest = (state) => state.merge({
  ...state,
  loading: true,
});

const getNotificationsSuccess = (state, { data }) => state.merge({
  data,
  loading: false,
  error: false,
});

const getNotificationsFailure = (state) => state.merge({
  ...state,
  error: true,
  loading: false,
});

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_NOTIFICATIONS_REQUEST]: getNotificationsRequest,
  [Types.GET_NOTIFICATIONS_SUCCESS]: getNotificationsSuccess,
  [Types.GET_NOTIFICATIONS_FAILURE]: getNotificationsFailure,
});
